import { faGift, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { CASE_TYPES } from '../../config/constants/common';

const HeaderNavigationItem = ({ name, path }) => {
  return (
    <>
      {name === 'London' && (
        <li className="navigation-item">
          <a
            className="navigation-link"
            href={`${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${path}`}
          >
            <FontAwesomeIcon
              className="navigation__icon"
              icon={faMapMarkerAlt}
            />
            <span style={{ minWidth: '60px' }}>London</span>
          </a>
        </li>
      )}
      {name === 'Gifts' && (
        <li className="navigation-item">
          <div className="gift">
            <a
              className="navigation-link"
              href={`${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${path}`}
            >
              <FontAwesomeIcon className="navigation__icon" icon={faGift} />
              {name}
            </a>
          </div>
        </li>
      )}
      {name !== 'London' && name !== 'Gifts' && (
        <li className="navigation-item">
          <a
            className="navigation-link"
            href={`${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${path}`}
          >
            {name}
          </a>
        </li>
      )}

      <style jsx>{`
        :global(.navigation__icon) {
          margin-right: 5px;
          position: relative;
          top: -1px;
          height: 14px;
          width: 14px;
        }

        @media (max-width: 767.98px) {
          .container {
            padding: 0;
            overflow: auto;
          }
        }
        .navigation-item {
          list-style: none;
          align-items: center;
          border-top: 2px solid transparent;
          border-bottom: 2px solid transparent;
        }
        .navigation-item--selected {
          border-bottom: 2px solid #eb008c;
        }
        .navigation-item--selected > .navigation-link {
          color: #eb008c;
        }
        .navigation-item--disabled {
          pointer-events: none;
        }
        .navigation-item--special {
          background-color: #fff;
          border-bottom: 0;
        }
        .navigation-item--special .navigation-link {
          color: #eb008c;
        }

        .navigation-link {
          height: 100%;
          color: #666666;
          cursor: pointer;
          padding: 0 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-transform: ${CASE_TYPES.upperCase};
          text-decoration: none;
          font-size: 13px;
          white-space: nowrap;
        }
        .navigation-link:hover {
          color: #eb008c;
        }
        .popover-animation {
          animation-fill-mode: backwards;
          animation: popover-in 0.2s;
        }

        @media (min-width: 1200px) {
          .navigation-item:nth-child(-n + 15) {
            display: flex;
          }
        }

        @media (min-width: 992px) {
          .navigation-item:nth-child(-n + 7) {
            display: flex;
          }
        }

        @media (min-width: 768px) {
          .navigation-item:nth-child(-n + 5) {
            display: flex;
          }
        }

        @media (max-width: 767.98px) {
          .navigation-item {
            display: flex;
          }
          .navigation-link {
            padding: 0 15px;
          }
        }
        .gift {
          display: flex;
        }
        .gift > a {
          align-items: center;
          background-color: #eb008c;
          border-bottom: 2px solid transparent;
          color: #ffffff;
          cursor: pointer;
          display: flex;
          font-size: 13 px;
          justify-content: center;
          padding: 10px 10px 5px 10px;
          text-decoration: none;
          text-transform: ${CASE_TYPES.upperCase};
          white-space: nowrap;
          height: 100%;
        }
      `}</style>
    </>
  );
};
HeaderNavigationItem.propTypes = {
  name: PropTypes.string,
  path: PropTypes.string,
};
export default HeaderNavigationItem;
